"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endpoints = void 0;
exports.list = list;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _requests = require("@edison/requests");
var _constants = require("../utils/constants");
var _utils = require("./utils");
var endpoints = exports.endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/beta_feature/list");
    }
  }
};
/**
 * Returns a list of available feature ID
 *
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<ListResponse>}
 */
function list(_x) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, options, _endpoints$list, method, url, res, _res$result, blIDs, newBlIDs, features, newFeatures, featureSet, newFeatureSet, _key, id, name;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth;
          options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context.sent;
          _res$result = res.result, blIDs = _res$result.blIDs, newBlIDs = _res$result.newBlIDs;
          features = {}, newFeatures = {};
          featureSet = new Set(blIDs), newFeatureSet = new Set(newBlIDs);
          for (_key in _constants.betaFeatureIds) {
            id = _constants.betaFeatureIds[_key];
            name = _constants.betaFeatures[_key];
            features[name] = featureSet.has(id);
            newFeatures[name] = newFeatureSet.has(id);
          }
          return _context.abrupt("return", {
            features: features,
            newFeatures: newFeatures
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
//# sourceMappingURL=beta-features.js.map